// import { Link } from "react-router-dom";
import AuthUser from "../../../widgets/auth-user/ui/AuthApp";

export function LoginPage() {
    
    return (
        <div className="login-container">
            <AuthUser></AuthUser>
            {/* <footer className="footer text-secondary">
                <p className="d-flex">
                    <div className="footer_svg"></div>
                    copyright 2023 
                    <Link to={"/login/"} className="footer_link">Политика конфеденциальности</Link>  
                </p>                              
            </footer> */}
                            
        </div>
    )
}
